import Model from 'flarum/common/Model';

export default class Event extends Model {
  title = Model.attribute('title');
  description = Model.attribute('description');
  location = Model.attribute('location');
  eventDate = Model.attribute('eventDate');
  eventEndDate = Model.attribute('eventEndDate');
  isPrivate = Model.attribute('isPrivate');
  eventStatus = Model.attribute('eventStatus');
  attendeeCount = Model.attribute('attendeeCount');
  notAttendingCount = Model.attribute('notAttendingCount');
  noResponseCount = Model.attribute('noResponseCount');
  totalMembersCount = Model.attribute('totalMembersCount');
  membersWithoutResponse = Model.attribute('membersWithoutResponse');
  sectionSummary = Model.attribute('sectionSummary');
  myStatus = Model.attribute('myStatus');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  canRsvp = Model.attribute('canRsvp');
  canExport = Model.attribute('canExport');
  canEdit = Model.attribute('canEdit');

  discussion = Model.hasOne('discussion');
  user = Model.hasOne('user');
  rsvps = Model.hasMany('rsvps');
}
